// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".niqfA {\n  background-color: var(--surface-secondary-default);\n  padding: var(--space-50);\n  gap: var(--space-100);\n  border-radius: var(--radius-100);\n  height: var(--space-500);\n}\n\n.UoUKK,\n.UoUKK:hover,\n.UoUKK:active {\n  background-color: var(--surface-brand-default) !important;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": "niqfA",
	"button": "UoUKK"
};
export default ___CSS_LOADER_EXPORT___;
